import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import axios from 'axios'
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify)

const fetchThemeConfig = async () => {
  try {
    const response = await axios.get('/config/theme')
    return response.data
  } catch (error) {
    console.error('Error fetching theme configuration:', error)
    return null
  }
}

const createVuetifyInstance = async () => {
  const themeConfig = await fetchThemeConfig()

  return new Vuetify({
    theme: {
      themes: {
        light: {
          primary: themeConfig?.light.primary || colors.blue.base,
          secondary: themeConfig?.light.secondary || colors.blue.lighten4,
          accent: themeConfig?.light.accent || colors.indigo.base,
          error: themeConfig?.light.error || colors.red.accent3,
          info: themeConfig?.light.info || colors.blue.base,
          success: themeConfig?.light.success || colors.green.base,
          warning: themeConfig?.light.warning || colors.amber.base
        },
        dark: {
          primary: themeConfig?.dark.primary || colors.blue.darken2,
          secondary: themeConfig?.dark.secondary || colors.purple.lighten2,
          accent: themeConfig?.dark.accent || colors.orange.darken3,
          error: themeConfig?.dark.error || colors.deepOrange.accent4,
          info: themeConfig?.dark.info || colors.lightBlue.lighten1,
          success: themeConfig?.dark.success || colors.lightGreen.accent3,
          warning: themeConfig?.dark.warning || colors.deepOrange.base
        }
      }
    }
  })
}

export default createVuetifyInstance
